import React from 'react';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = "Confirm", cancelText = "Cancel", type = "danger" }) => {
  if (!isOpen) return null;

  const typeStyles = {
    danger: {
      button: "bg-red-600 hover:bg-red-700",
      icon: "⚠️",
      iconBg: "bg-red-900/30"
    },
    warning: {
      button: "bg-orange-600 hover:bg-orange-700",
      icon: "⚠️",
      iconBg: "bg-orange-900/30"
    },
    info: {
      button: "bg-blue-600 hover:bg-blue-700",
      icon: "ℹ️",
      iconBg: "bg-blue-900/30"
    },
    success: {
      button: "bg-green-600 hover:bg-green-700",
      icon: "✓",
      iconBg: "bg-green-900/30"
    }
  };

  const style = typeStyles[type] || typeStyles.danger;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4 z-[9999]" onClick={onClose}>
      <div 
        className="bg-gradient-to-br from-gray-900 to-black border-2 border-orange-500/30 rounded-2xl shadow-2xl max-w-md w-full fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Icon */}
        <div className="p-6 pb-4 flex justify-center">
          <div className={`${style.iconBg} rounded-full w-20 h-20 flex items-center justify-center`}>
            <span className="text-4xl">{style.icon}</span>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 pb-6 text-center">
          <h3 className="text-2xl font-bold text-white mb-3">{title}</h3>
          <p className="text-gray-300 whitespace-pre-line">{message}</p>
        </div>

        {/* Actions */}
        <div className="px-6 pb-6 flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-3 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-semibold transition-colors"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className={`flex-1 px-4 py-3 ${style.button} text-white rounded-lg font-semibold transition-colors`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
